// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"UsersPage_tableContainer__koFNJ","users-table":"UsersPage_users-table__KZv58"};